<template>
	<div class="ce-video">
		<video class="video-elem" muted autoplay>
			<source :src="objectdata.playerSRC" type="video/mp4" />
		</video>
	</div>
</template>
<script>
	import Base from "./Base.vue";
	export default {
		extends: Base,
		props: {
			type: false,
			objectdata: {}
		},

		data() {
			return {};
		},
		mounted() {
			this.playVideo();
		},
		created() {
			// this.playVideo();
			this.setPlayerOptions();
		},
		methods: {
			setPlayerOptions() {
				let playerOptions = "";
				let arrPlayerOption = this.objectdata.playerOptions;

				setTimeout(() => {
					let videoElem = document.querySelector(".video-elem");

					if (arrPlayerOption.includes("player_autoplay")) {
						videoElem.setAttribute("autoplay", "true");
					}
					if (!arrPlayerOption.includes("player_nocontrols")) {
						videoElem.setAttribute("controls", "");
					}
					if (arrPlayerOption.includes("player_loop")) {
						videoElem.setAttribute("loop", "");
					}
					if (arrPlayerOption.includes("player_playsinline")) {
						videoElem.setAttribute("playsinline", "");
					}
					if (arrPlayerOption.includes("player_muted")) {
						videoElem.setAttribute("muted", "muted");
					} else {
						videoElem.removeAttribute("muted");
					}
				}, 400);
				// setTimeout(() => {
				// 	this.playVideo();
				// }, 700);
			},
			playVideo(event) {
				var b = setInterval(() => {
					var elem = document.querySelector(".ce-video video");

					if (elem) {
						if (elem.readyState >= 3) {
							if (!elem.playing) {
								elem = elem;
								elem.play();
							}
							clearInterval(b);
						}
					}
				}, 500);
			}
		},
		composed: {}
	};
</script>

<style lang="scss">
	@import "@/scss/variables.scss";
	@import "@/scss/mixins.scss";
	.ce-video {
		height: 0;
		// margin: 0 auto;
		overflow: hidden;
		padding-bottom: 56.25%;
		position: relative;
		width: 100%;
		// @include min-screen($screen-min-m) {
		// 	margin-bottom: 80px;
		// }
		video {
			position: absolute;
			top: 0;
			left: 0;
			width: 100%;
			height: 100%;
		}
	}
</style>